"use client";

import { APP_URL } from "@/lib/constants";
import { Dialog, DialogPanel } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { useAppEvents } from "@jace/insights";
import { Button, HStack } from "@jace/ui";
import Link from "next/link";
import { useState } from "react";
import { CtaButton } from "./cta-button";
import { JaceLogo } from "./jace-logo";

interface MobileMenuProps {
	navigation: Array<{ name: string; href: string }>;
}

export function MobileMenu({ navigation }: MobileMenuProps) {
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
	const { emit } = useAppEvents();

	return (
		<>
			<div className="flex lg:hidden">
				<button
					type="button"
					onClick={() => setMobileMenuOpen(true)}
					className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white"
				>
					<span className="sr-only">Open main menu</span>
					<Bars3Icon aria-hidden="true" className="size-6" />
				</button>
			</div>

			<Dialog
				open={mobileMenuOpen}
				onClose={setMobileMenuOpen}
				className="lg:hidden"
			>
				<div className="fixed inset-0 z-50" />
				<DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-surface-bg px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10 ">
					<div className="flex items-center justify-between">
						<Link href="/" className="-m-1.5 p-1.5">
							<span className="sr-only">Jace AI</span>
							<JaceLogo className="fill-white w-[50px] sm:w-[70px]" />
						</Link>
						<button
							type="button"
							onClick={() => setMobileMenuOpen(false)}
							className="-m-2.5 rounded-md p-2.5 text-text-muted"
						>
							<span className="sr-only">Close menu</span>
							<XMarkIcon aria-hidden="true" className="size-6" />
						</button>
					</div>
					<div className="mt-6 flow-root">
						<div className="-my-6 divide-y divide-white/10">
							<div className="space-y-2 py-6">
								{navigation.map((item) => (
									<Link
										key={item.name}
										href={item.href}
										className="-mx-3 block rounded-lg px-3 py-2 text-xl/7 font-semibold text-white"
										onClick={() => setMobileMenuOpen(false)}
									>
										{item.name}
									</Link>
								))}
							</div>
							<HStack className="py-6 w-full gap-2">
								<Button
									intent="default"
									size="lg"
									asChild
									className="w-full"
									onClick={() => {
										setMobileMenuOpen(false);
										emit({
											type: "signin_click",
											payload: { placement: "mobile_menu" },
										});
									}}
								>
									<a href={`${APP_URL}/signin`}>Log In</a>
								</Button>
								<CtaButton
									className="w-full"
									placement="mobile_menu"
									onClick={() => setMobileMenuOpen(false)}
								/>
							</HStack>
						</div>
					</div>
				</DialogPanel>
			</Dialog>
		</>
	);
}
